module.exports = __webpack_public_path__ + "img/sorticon.b329ddbe.svg";